import { gql } from "generated-graphql";

export const GET_STAFF_CERS_REJECTION_FINDINGS = gql(`
  query StaffCersRejectionFindings($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    staffCersRejectionFindings(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        facilityName
        encampFacilityId
        encampFacilityName
        encampTenantId
        tenantName
        csmName
        cupaCode
        cupaName
        module
        status
        resolutionType
        decisionDate
        detectedAt
        resolvedAt
        commentType
        issueCategories
        llmSummary
        revisionReportId
      }
      count
      stats {
        unresolved
        oocOver30
        pending
        resolvedThisMonth
        age30to60
        age60to90
        age90plus
      }
    }
  }
`);
